export default function AboutStory() {
  const stats = [
    { value: '5000+', label: '收录漫画' },
    { value: '1000万+', label: '注册用户' },
    { value: '98%', label: '平台好评率' },
    { value: '8', label: '年持续运营' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="lg:w-1/2">
            <span className="text-xs font-medium text-foreground-500 tracking-widest">
              品牌故事
            </span>

            <div className="mt-8 max-w-lg">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                关于178漫画网
              </h1>
              <p className="mt-6 text-foreground-700 leading-relaxed text-sm md:text-base">
                178漫画网创立于2018年，是国内领先的<strong>高清漫画在线阅读平台</strong>。我们致力于为广大漫画爱好者提供优质的<strong>免费阅读</strong>体验，平台汇聚了海量正版授权漫画资源，涵盖<strong>治愈、热血、恋爱、悬疑</strong>等多种类型。
              </p>
              <p className="mt-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                我们深知每一位读者对于画质和阅读体验的追求。因此，178漫画网全部采用<strong>超清画质</strong>呈现，并创新性地推出<strong>下拉式阅读</strong>模式，让翻页更加流畅自然，真正实现沉浸式的<strong>视觉盛宴</strong>。
              </p>
              <p className="mt-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                从最初的几十部漫画，到如今超过<strong>5000部</strong>作品的庞大资源库；从寥寥数千读者，到<strong>千万级</strong>的用户群体——178漫画网的每一步成长，都离不开每一位读者的支持与信任。
              </p>
              <p className="mt-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                我们的使命是：<strong>让好故事被每一个读者看见</strong>。无论你是追更党还是补番族，无论你喜欢热血战斗还是温暖治愈，在178漫画网，你都能找到属于你的那一部作品。
              </p>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 gap-5 md:gap-6">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="p-6 md:p-8 rounded-2xl bg-background-50 text-center"
                >
                  <span className="font-heading text-3xl md:text-5xl font-black text-foreground-900">
                    {stat.value}
                  </span>
                  <p className="text-sm text-foreground-500 mt-2 font-medium">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}